import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {AdService} from '@services/ad.service';

@Component({
    selector: 'app-recap-loyer',
    templateUrl: './recap-loyer.component.html',
    styleUrls: ['./recap-loyer.component.scss']
})
export class RecapLoyerComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    rentDetail = false;
    chargeDetail = false;

    constructor(public adService: AdService) {
    }

    ngOnInit() {
    }

    edit(event) {
        this.favorite = this.adService.cleanInput(this.favorite);

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    showRentDetail() {
        this.rentDetail = true;
    }

    hideRentDetail() {
        this.rentDetail = false;
    }

    showChargeDetail() {
        this.chargeDetail = true;
    }

    hideChargeDetail() {
        this.chargeDetail = false;
    }

}
